import { useEffect, useRef, useState } from "react";
import "../Design/Color.css"
import { Button, Input, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextareaAutosize } from "@mui/material";
import { APIEventAndPayment } from "src/handler/accountHandler";
import UserLoader from "src/Dashboard/UserLoader";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
const EventAndPayment = () => {
    const [section, setSection] = useState("GetEvent");
    const [loader, setLoader] = useState(true);
    const [getEvent, setGetEvent] = useState([{
        "eventId": 0,
        "eventName": "",
        "eventDescription": "",
        "locationAddress": "",
        "eventDate": "",
        "eventTime": "",
        "ticketPrice": 0,
        "eventImage": ""
    }])
    const [eventUpdate, setEventUpdate] = useState({
        "eventId": 0,
        "eventName": "",
        "eventDescription": "",
        "locationAddress": "",
        "eventDate": "",
        "eventTime": "",
        "ticketPrice": 0,
        "eventImage": ""
    });
    const [getEventPayment,setGetEventPament] = useState([
      {
        "eventPaymentId": 0,
        "transactionId": 0,
        "eventId": 0,
        "payment": 0,
        "status": 1,
        "paymentDate": "",
        "growniverseId": "",
        "userInformationId": 0,
        "imageData":null
      }
    ]);
    const [file, setFile] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);
    const runOnce = useRef(false);
    const handleFileChange = (event: any) => {
        setFile(event.target.files[0]);
    };
    const addEventFormData = new FormData();
    const handelOnChange = (name: string, e: any) => {
        const value = e.target.value;
        setEventUpdate((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const GetEvent = async () => {
        addEventFormData.append("enumEventAndPayment", "1");
        var response = await APIEventAndPayment(addEventFormData);
        setGetEvent(response.data.getEventDto);
    }

    const DeleteEvent = async (deleteEventId: number) => {
        setLoader(true);
        addEventFormData.append("enumEventAndPayment", "3");
        addEventFormData.append("addEventDto.eventId", deleteEventId.toString());
        var response = await APIEventAndPayment(addEventFormData);
        setGetEvent(response.data.getEventDto);
        setLoader(false);
    }

    useEffect(() => {
        if (runOnce.current === false) {
            GetEvent();
            runOnce.current = true;
            setLoader(false);
        }
    }, [runOnce]);
    const AddUpdate = async (event: any) => {
        event.preventDefault();
        
        setLoader(true);
        if (!file) {
            alert('Please select a file before submitting.');
            setLoader(false);
            return;
        }
        addEventFormData.append("enumEventAndPayment", "2");
        if (isUpdate) {
            addEventFormData.append("addEventDto.eventId", eventUpdate.eventId.toString());
        }
        addEventFormData.append("addEventDto.eventName", eventUpdate.eventName);
        addEventFormData.append("addEventDto.eventDescription", eventUpdate.eventDescription);
        addEventFormData.append("addEventDto.locationAddress", eventUpdate.locationAddress);
        addEventFormData.append("addEventDto.ticketPrice", eventUpdate.ticketPrice.toString());
        addEventFormData.append("addEventDto.eventDate", eventUpdate.eventDate);
        addEventFormData.append("addEventDto.eventTime", eventUpdate.eventTime);
        addEventFormData.append("addEventDto.eventImage", file);
        var response = await APIEventAndPayment(addEventFormData);
        setGetEvent(response.data.getEventDto);
        setSection("GetEvent");
        setLoader(false);
    }

    const formatDateTime = (dateOnly, timeOnly) => {
        // Convert DateOnly (YYYY-MM-DD) and TimeOnly (HH:MM:SS) into a full Date object
        const dateTimeString = `${dateOnly}T${timeOnly}`;
        const date = new Date(dateTimeString);

        // Format the output
        return date.toLocaleString("en-US", {
            weekday: "long",  // Day name (e.g., Monday)
            day: "2-digit",    // Day (e.g., 20)
            month: "long",     // Month name (e.g., May)
            year: "numeric",   // Year (e.g., 2025)
            hour: "2-digit",   // Hour (e.g., 11)
            minute: "2-digit", // Minute (e.g., 02)
            hour12: true       // AM/PM format
        });
    };

    const GetEventPayments = async (eventId:number) =>{
        setLoader(true);
        addEventFormData.append("enumEventAndPayment", "4");
        addEventFormData.append("AddEventPaymentDto.eventId", eventId.toString());
        var response = await APIEventAndPayment(addEventFormData);
        setGetEventPament(response.data.getEventPaymentList);
        setSection("GetPayment");
        setLoader(false);
    }

    const AcceptRejectPayment = async (eventPaymentId: number, userInformationId: number, isAccept: boolean) => {
        setLoader(true);
        addEventFormData.append("enumEventAndPayment", "6");
        addEventFormData.append("eventPaymentId", eventPaymentId.toString());
        addEventFormData.append("paymentUserInformationId", userInformationId.toString());
        addEventFormData.append("isAccept", isAccept.toString());
        var response = await APIEventAndPayment(addEventFormData);
        setGetEventPament(response.data.getEventPaymentList);
        setSection("GetPayment");
        setLoader(false);
    }


    return (
        <>
            {
                loader ? <>
                    <UserLoader />
                </> : <>
                    {
                        section === "GetEvent" ?
                            <>
                                <section>
                                    <TableContainer style={{ background: "white" }}>
                                        <h3 style={{ textAlign: "center" }}>Events</h3>
                                        <div className="text-center">
                                            <Button className="btn btn-primary p-3 bg-g1 color-white" onClick={() => { setIsUpdate(false); setSection("AddEvent") }}>Add Event</Button>
                                        </div>
                                        <Table>
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell className="fw-bold" align="center">Event Id</TableCell>
                                                    <TableCell className="fw-bold" align="center">Event Description</TableCell>
                                                    <TableCell className="fw-bold" align="center">Event Name</TableCell>
                                                    <TableCell className="fw-bold" align="center">Date Of Event</TableCell>
                                                    <TableCell className="fw-bold" align="center">Location Address</TableCell>
                                                    <TableCell className="fw-bold" align="center">Ticket Price</TableCell>
                                                    <TableCell className="fw-bold" align="center">Event Image</TableCell>
                                                    <TableCell className="fw-bold" align="center">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {
                                                getEvent.map((data) => (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell className="fw-bold" align="center">{data.eventId}</TableCell>
                                                            <TableCell align="center">{data.eventName}</TableCell>
                                                            <TableCell align="center">{data.eventDescription}</TableCell>
                                                            <TableCell align="center">{formatDateTime(data.eventDate, data.eventTime)}</TableCell>
                                                            <TableCell align="center">{data.locationAddress}</TableCell>
                                                            <TableCell align="center">{data.ticketPrice}</TableCell>
                                                            <TableCell align="center"><img src={`data:image/jpeg;base64,${data.eventImage}`} alt="Decoded from Base64" style={{ width: "300px", height: "100%" }} /></TableCell>
                                                            <TableCell><Button style={{ background: "green",color:"white" }} onClick={() => {
                                                                setIsUpdate(true);
                                                                setSection("AddEvent");
                                                                setEventUpdate(data);
                                                            }}>Update</Button></TableCell>
                                                            <TableCell><Button className="bg-danger" style={{color:"white"}} onClick={() => { DeleteEvent(data.eventId) }}>Delete</Button></TableCell>
                                                            <TableCell><Button style={{background:"black",color:"white"}}  onClick={() => { GetEventPayments(data.eventId) }}>Payments</Button></TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                ))
                                            }
                                        </Table>
                                        {/* <TablePagination
                                    rowsPerPageOptions={[10, 20]}
                                    component="div"
                                    count={pendingRequest.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}
                                    </TableContainer>
                                </section>
                            </> :
                            <>
                                {
                                    section === "AddEvent" ?
                                        <>
                                            <section>
                                                <h3 style={{ textAlign: "center" }}>Events</h3>
                                                <div className="text-center">
                                                    <Button className="btn btn-primary p-3 bg-g1 color-white" onClick={() => { setSection("GetEvent") }}>Back</Button>
                                                    <form onSubmit={AddUpdate}>
                                                        <TableContainer style={{ background: "white" }}>
                                                            <Table>
                                                                {
                                                                    isUpdate &&
                                                                    <>
                                                                        <TableHead>
                                                                            <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                                Event Id
                                                                            </TableCell>
                                                                            <TableCell align='center'>
                                                                                {eventUpdate.eventId}
                                                                            </TableCell>
                                                                        </TableHead>
                                                                    </>
                                                                }
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Event Name
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <Input placeholder='Event Name' value={eventUpdate.eventName} onChange={(e) => { handelOnChange("eventName", e) }} required />
                                                                    </TableCell>
                                                                </TableHead>
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Event Description
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <TextareaAutosize value={eventUpdate.eventDescription} onChange={(e) => { handelOnChange("eventDescription", e) }} placeholder='Event Description' required />
                                                                    </TableCell>
                                                                </TableHead>
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Ticket Price
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <Input value={eventUpdate.ticketPrice} onChange={(e) => { handelOnChange("ticketPrice", e) }} type='number' />
                                                                    </TableCell>
                                                                </TableHead>
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Event Date
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <Input value={eventUpdate.eventDate} onChange={(e) => { handelOnChange("eventDate", e) }} type='Date' />
                                                                    </TableCell>
                                                                </TableHead>
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Event Time
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <Input value={eventUpdate.eventTime} onChange={(e) => { handelOnChange("eventTime", e) }} type='time' />
                                                                    </TableCell>
                                                                </TableHead>
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Location Address
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <Input value={eventUpdate.locationAddress} onChange={(e) => { handelOnChange("locationAddress", e) }} />
                                                                    </TableCell>
                                                                </TableHead>
                                                                <TableHead>
                                                                    <TableCell align='center' style={{ fontWeight: "bold" }}>
                                                                        Poster
                                                                    </TableCell>
                                                                    <TableCell align='center'>
                                                                        <Input name='imageFileData' type="file" onChange={handleFileChange} required />
                                                                    </TableCell>
                                                                </TableHead>
                                                            </Table>
                                                            <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", paddingTop: "40px" }}>
                                                                <Button className='headerBackground' style={{ color: "white", padding: "10px", borderRadius: "10px" }} type='submit'>Add/Update</Button>
                                                            </div><br />
                                                        </TableContainer>
                                                    </form>
                                                </div>
                                            </section>
                                        </> : <>
                                            {
                                                    section === "GetPayment"
                                                        ?
                                                        <>
                                                            <TableContainer style={{ background: "white" }}>
                                                                <h3 style={{ textAlign: "center" }}>Events</h3>
                                                                <div className="text-center">
                                                                    <Button className="btn btn-primary p-3 bg-g1 color-white" onClick={() => { setIsUpdate(false); setSection("GetEvent") }}>Back</Button>
                                                                </div>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow >
                                                                            <TableCell className="fw-bold" align="center">Event Payment Id</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Event Id</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Grownverse Id</TableCell>
                                                                            <TableCell className="fw-bold" align="center">UserInformation Id</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Payment Date</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Transaction Id</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Payment</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Image</TableCell>
                                                                            <TableCell className="fw-bold" align="center">Action</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    {
                                                                        getEventPayment.map((data) => (
                                                                            <TableBody>
                                                                                <TableRow>
                                                                                    <TableCell className="fw-bold" align="center">{data.eventPaymentId}</TableCell>
                                                                                    <TableCell align="center">{data.eventId}</TableCell>
                                                                                    <TableCell align="center">{data.growniverseId}</TableCell>
                                                                                    <TableCell align="center">{data.userInformationId}</TableCell>
                                                                                    <TableCell align="center">{data.paymentDate}</TableCell>
                                                                                    <TableCell align="center">{data.transactionId}</TableCell>
                                                                                    <TableCell align="center">{data.payment}</TableCell>
                                                                                    <TableCell align="center"><img src={`data:image/jpeg;base64,${data.imageData}`} alt="Decoded from Base64" style={{ width: "300px", height: "100%" }} /></TableCell>
                                                                                    {
                                                                                        data.status === 1 ?
                                                                                        <TableCell align="center">
                                                                                        <div style={{
                                                                                            display: "flex",
                                                                                            gap: "10px",
                                                                                            justifyContent: "center",
                                                                                            alignItems: "center"
                                                                                        }}>
                                                                                            <Button
                                                                                                style={{
                                                                                                    backgroundColor: "#28a745",
                                                                                                    color: "#fff",
                                                                                                    fontSize: "16px",
                                                                                                    fontWeight: "600",
                                                                                                    padding: "8px 16px",
                                                                                                    borderRadius: "6px",
                                                                                                    border: "none",
                                                                                                    cursor: "pointer",
                                                                                                    transition: "0.3s ease",
                                                                                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.2)"
                                                                                                }}
                                                                                                onClick={() => { AcceptRejectPayment(data.eventPaymentId, data.userInformationId, true) }}
                                                                                            >
                                                                                                ✅ Accept
                                                                                            </Button>

                                                                                            <Button
                                                                                                style={{
                                                                                                    backgroundColor: "#dc3545",
                                                                                                    color: "#fff",
                                                                                                    fontSize: "16px",
                                                                                                    fontWeight: "600",
                                                                                                    padding: "8px 16px",
                                                                                                    borderRadius: "6px",
                                                                                                    border: "none",
                                                                                                    cursor: "pointer",
                                                                                                    transition: "0.3s ease",
                                                                                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.2)"
                                                                                                }}
                                                                                                onClick={() => { AcceptRejectPayment(data.eventPaymentId, data.userInformationId, false) }}
                                                                                            >
                                                                                                ❌ Reject
                                                                                            </Button>
                                                                                        </div>
                                                                                    </TableCell>:
                                                                                    <>
                                                                                    {
                                                                                        data.status === 2 ? <span style={{color:"green",fontWeight:"bold"}}>Accepted</span> : <span style={{color:"red",fontWeight:"bold"}}>Rejected</span>
                                                                                    }
                                                                                    </>
                                                                                    }
                                                                                </TableRow>
                                                                            </TableBody>
                                                                        ))
                                                                    }
                                                                </Table>
                                                            </TableContainer>
                                                    </> : <></>
                                            }
                                        </>
                                }
                            </>
                    }
                </>
            }
        </>
    )
};

export default EventAndPayment;
